var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 70.3c0-.5.4-1 1-1L28 68.2a1 1 0 0 1 .8 1.7L15.7 81.8a1 1 0 0 1-1.7-.7l-.1-10.8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 31H8a8 8 0 0 0-8 8v25a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-4H34a12 12 0 0 1-12-12V31Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46.6c.7-.1 1.2.4 1.2 1l.5 22c0 .9-.8 1.3-1.4.8L54 52.8c-.7-.6-.5-1.8.3-2L76 46.6Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 0a8 8 0 0 0-8 8v40.7a8 8 0 0 0 8 8h55a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H33Zm52 17H36v3h49v-3ZM36 39h49v3H36v-3Zm49-11H36v3h49v-3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessagesIcon);
export default __webpack_public_path__ + "static/media/chat_messages_icon.d768cb27592eb970c528a5e9cb6ff478.svg";
export { ForwardRef as ReactComponent };